
export const GITHUB_ISSUE_URL = 'https://github.com/huggingface/transformers.js/issues/new/choose';

export const CONFIG_NAME = "config.json"
export const FEATURE_EXTRACTOR_NAME = "preprocessor_config.json"
export const IMAGE_PROCESSOR_NAME = FEATURE_EXTRACTOR_NAME
export const PROCESSOR_NAME = "processor_config.json"
export const CHAT_TEMPLATE_NAME = "chat_template.jinja"
export const GENERATION_CONFIG_NAME = "generation_config.json"
